// extracted by mini-css-extract-plugin
module.exports = {"mobileWrapper":"ForgotPassword_mobileWrapper__2nTH2","action":"ForgotPassword_action__36z6C","success":"ForgotPassword_success__3uYUD"};